import { UserHelper } from '@Helper/Infra';
import { MenuItem } from '@mui/material';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type ExcelExportProps = {
  type?: string;
  id?: string;
};

const ExcelExport: FC<ExcelExportProps> = ({ type, id }) => {
  const { t } = useTranslation();

  let userHelper = new UserHelper();

  const handleDownload = async () => {
    const response = await userHelper.getExcel(id ? id : '', type ? type : '');

    let workbook = new Workbook();
    let recievedBook = workbook.xlsx.load(response?.data);

    (await recievedBook).xlsx.writeBuffer().then((buffer: BlobPart) => {
      saveAs(
        new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        `${type}.xlsx`
      );
    });
  };

  return (
    <MenuItem onClick={handleDownload} className="dashboardMenu">
      {' '}
      {t('dashboard.export_as_excel')}
    </MenuItem>
  );
};

export default ExcelExport;
